import { render, staticRenderFns } from "./2_PerfilEstudianteEduContinua.vue?vue&type=template&id=1ff7c430&scoped=true"
import script from "./2_PerfilEstudianteEduContinua.vue?vue&type=script&lang=ts"
export * from "./2_PerfilEstudianteEduContinua.vue?vue&type=script&lang=ts"
import style0 from "./2_PerfilEstudianteEduContinua.vue?vue&type=style&index=0&id=1ff7c430&prod&lang=css"
import style1 from "./2_PerfilEstudianteEduContinua.vue?vue&type=style&index=1&id=1ff7c430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7c430",
  null
  
)

export default component.exports